/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowRoadTripTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowRoadTrip,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Hit the Road!",
    "Adventure Awaits on the Open Road!",
    "Let’s Go for a Drive!",
  ],
  title: "Road Trip",
  description: "Plan an exciting road trip adventure.",
  longDescription:
    "Gather your friends for a memorable road trip! Choose a date, pick your destination, and decide on stops along the way!",
  emoji: "🚗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Road Trip",
          emoji: "🚗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the road trip?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a destination?",
            description: "Where do we want to go for our road trip?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What destination should we choose?",
                emoji: "🗺",
                completeAction: {
                  question: "Decide on stops along the way?",
                  description: "What stops should we make during our trip?",
                  addModules: [
                    {
                      type: ModuleType.Location,
                      doneType: ModuleDoneType.Voting,
                      title: "What stops should we plan?",
                      emoji: "🛣",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Adventure Awaits!",
    outroDescription:
      "Your road trip plans are set! Enjoy the journey and destination!",
  },
};
